import React from 'react';
import { Drawer, Select, Button, Table, Tag, Tooltip, Spin } from 'antd';
import { FilePdfOutlined, MailOutlined, DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import './index.css';

const ANDrawer = ({
  open,
  onClose,
  selectedAnTemplate,
  setSelectedAnTemplate,
  handleGeneratePdf,
  generateanLoading,
  sendanLoading,
  handleSendAnEmail,
  anEmailRecords,
  anRecordsLoading,
  fetchAnEmailRecords,
  pdfUrl,
}) => (
  <Drawer
    title="Arrival Notice / Freight Bill"
    placement="right"
    onClose={onClose}
    open={open}
    width='72%'
    destroyOnClose
    extra={
      <div style={{ display: 'flex', gap: '8px' }}>
        <Select
          style={{ minWidth: 120 }}
          placeholder="Select A/N Template"
          defaultValue={2}
          value={selectedAnTemplate?.value}
          onChange={(value, item) => {
            setSelectedAnTemplate(item || null);
          }}
          options={[
            { value: 1, label: 'AN-CAN' },
            { value: 2, label: 'AN-US-FCL' },
            { value: 3, label: 'AN-US-LCL' },
            { value: 4, label: 'PICK-UP NUMBER NOTICE-CAN' },
            { value: 5, label: 'PICK-UP NUMBER NOTICE-US' },
          ]}
        />

        <Button
          type="primary"
          icon={<FilePdfOutlined />}
          onClick={handleGeneratePdf}
          loading={generateanLoading}
        />

        <Button
          type="default"
          icon={<MailOutlined />}
          onClick={handleSendAnEmail}
          loading={sendanLoading}
        >
          Send Email
        </Button>
      </div>
    }
  >
    {generateanLoading ? (
      <div className="email-loading">
        <Spin tip="Loading" size="large" />
      </div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* A/N 邮件发送记录表格 */}
        <div style={{ marginBottom: 10, minHeight: 300, maxHeight: 360, overflow: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
            <Button
              type="primary"
              size="small"
              icon={<ReloadOutlined />}
              loading={anRecordsLoading}
              onClick={fetchAnEmailRecords}
            >
              Refresh
            </Button>
          </div>

          <Table
            dataSource={anEmailRecords}
            rowKey="id"
            size="small"
            pagination={false}
            scroll={{ x: 'max-content', y: 420 }}
            fixedHeader={true}
            columns={[
              {
                title: 'Subject',
                dataIndex: 'subject',
                key: 'subject',
                width: 200,
                render: (subject) => (
                  <Tooltip title={subject}>
                    <div style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {subject}
                    </div>
                  </Tooltip>
                ),
              },
              {
                title: 'Type',
                dataIndex: 'subject',
                key: 'type',
                width: 80,
                render: (subject) => {
                  if (subject?.includes('Arrival Notice')) return 'A/N';
                  if (subject?.includes('Pick-Up Number')) return 'P/U';
                  return '-';
                },
              },
              {
                title: 'Send Status',
                dataIndex: 'sendStatus',
                key: 'sendStatus',
                width: 120,
                render: (status) => {
                  const statusMap = {
                    0: { color: 'red', text: 'Failure' },
                    1: { color: 'green', text: 'Success' }
                  };
                  const statusInfo = statusMap[status] || { color: 'default', text: status };
                  return <Tag color={statusInfo.color}>{statusInfo.text}</Tag>;
                },
              },
              {
                title: 'Time',
                dataIndex: 'createdTime',
                key: 'createdTime',
                render: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '-',
              },
            ]}
          />
        </div>

        {/* PDF预览区域 */}
        <div style={{
          flex: 1,
          border: '1px solid #f0f0f0',
          borderRadius: '4px',
          padding: '8px'
        }}>
          <div
            style={{
              width: '100%',
              height: '100%',
              minHeight: 600,
              position: 'relative',
              border: 'none',
            }}
          >
            {pdfUrl ?
              <object
                data={pdfUrl}
                type="application/pdf"
                width="100%"
                height="100%"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  minHeight: '600px',
                  border: 'none'
                }}
              >
                <div style={{
                  width: '100%',
                  height: '100%',
                  minHeight: '600px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px dashed #d9d9d9',
                  borderRadius: 4,
                  padding: 24,
                  boxSizing: 'border-box',
                  background: '#fff',
                }}>
                  <FilePdfOutlined style={{ color: 'red', fontSize: '48px' }} />
                  <p style={{ color: '#999', margin: '12px 0 16px' }}>
                    PDF not view, Please new window to view
                  </p>
                  <div>
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      onClick={() => {
                        const a = document.createElement('a');
                        a.href = pdfUrl;
                        a.download = selectedAnTemplate.name || 'template.pdf';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                      }}
                      style={{ marginRight: 8 }}
                    >
                      Download
                    </Button>
                    <Button onClick={() => window.open(pdfUrl, '_blank')}>
                      New window to view
                    </Button>
                  </div>
                </div>
              </object>
              : <div style={{
                width: '100%',
                height: '100%',
                minHeight: '600px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px dashed #d9d9d9',
                borderRadius: 4,
                padding: 24,
                boxSizing: 'border-box',
                background: '#fff',
              }}>
                <FilePdfOutlined style={{ color: 'red', fontSize: '48px' }} />
                <p style={{ color: '#999', margin: '12px 0 16px' }}>
                  Please Generate PDF first.
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    )}
  </Drawer>
);

export default ANDrawer;
